/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { AlertCircleIcon } from 'lucide-react'
import type { ComponentProps } from 'react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { cn } from '@/lib/utils'

export type ErrorAlertProps = ComponentProps<'div'> & {
  error: Error
  title?: string
  /** Message shown when `error.message` is empty. Default: `An error occurred` */
  fallbackMessage?: string
}

export function ErrorAlert({ error, title, fallbackMessage = 'An error occurred', className }: ErrorAlertProps) {
  return (
    <div className={cn('mx-auto w-full max-w-4xl px-2 py-10', className)}>
      <Alert className="p-4" variant="destructive">
        <AlertCircleIcon />
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        <AlertDescription>{error?.message || fallbackMessage}</AlertDescription>
      </Alert>
    </div>
  )
}
